// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 3H16.5V1H7.5V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 6V4H2V6H4.02898L4.52898 23H12.4994C11.5579 21.7465 11 20.1884 11 18.5V8H13V13.4009C14.3697 11.9242 16.3269 11 18.5 11C18.9506 11 19.3919 11.0397 19.8206 11.1159L19.971 6H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 18.5C13 15.4624 15.4624 13 18.5 13C21.5376 13 24 15.4624 24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5ZM20.9142 19.5001L19.5 18.0857V16.252H17.5V18.9141L19.4999 20.9142L20.9142 19.5001Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-delete-time-filled')
export default class DeleteTimeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'delete-time-filled',
    }
  }
}
